import Reporter from "./reporter/reporter";
import LogHandler from "./handler/log-handler";
import ErrorHandler from "./handler/error-handler";

//如果是IE9，不进行日志上报。因为IE9没有console.log对象
//是否开启了客户端日志上报，默认为开启，不定义的情况下（undefined）也为开启。只有设置为false才关闭
window.xkwTracker = window.xkwTracker || {};
let isLogReportEnabled =  window.xkwTracker.$enable_client_log !== false;
if(isLogReportEnabled){
	LogHandler.init();
	ErrorHandler.init();
	window.xkwReporter = new Reporter();
}
